module.exports = "precision highp float;\n\nvarying vec3 v_color;\n\nvoid main() {\n  gl_FragColor = vec4(v_color, 1.0);\n}\n"